import React from 'react'
import Link from 'gatsby-link'
import Header from "../components/header";
// import CTA from "../components/cta";
import Countdown from "../components/countdown";
import SectionThree from "../components/section-three";
import SectionFour from "../components/section-four";
import SectionFive from "../components/section-five";
import SectionSix from "../components/section-six";
import SectionSeven from "../components/section-seven";
import TransformationSection from "../components/transformation-section";
import Speakers from "../components/speakers"
import ExpectSection from "../components/expect-section";
import BestVersion from "../components/best-version";
import Agenda from "../components/agenda";
import Pricing from "../components/pricing";
import RSVPSection from "../components/rsvp-section";
import Sponsors from "../components/sponsors";
import JoinusSection from "../components/joinus-section";
import Footer from "../components/footer";
// import BlackfridayWidget from "../components/blackfriday";

const IndexPage = () => (
    <div>
        <div className="row m0">
            <div className="col s12 p0">

               <Header />

                <Countdown />

                <SectionThree />

                <SectionFour />

                {/*<SectionFive/>*/}

                <SectionSix/>

                {/*<SectionSeven/>*/}

                {/*<TransformationSection/>*/}

                <Speakers />

                {/*<ExpectSection/>*/}

                {/*<BestVersion/>*/}

                <Agenda/>

                <Pricing/>

                <RSVPSection/>

                <Sponsors/>

                <JoinusSection/>

                <Footer/>

            </div>
        </div>
        {/*<Link to="/page-2/">Go to page 2</Link>*/}
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js